import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'
const state = {
    server_data: [],
}

const getters = {
    fundingRoundByOrganizationId: (state) => (id) => {

        return _.filter(state.server_data, function (o) { return o.organization === id }) || []
    },
    fundingRoundByOfferingId: (state) => (id) => {
        return _.filter(state.server_data, function (o) { return o._id === id }) || []
    },
    fundingRounds: (state) => state.server_data
}

const mutations = {
    initialize(state) {
        state.server_data = []
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.server_data = _.map(state.server_data, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.server_data = _.concat(state.server_data, payload)
        state.server_data = _.without(state.server_data, null, undefined)
    },
    remove(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        // remove the item by the id (either _id or uaid)
        state.server_data = _.filter(state.server_data, function (a) { return a._id !== payload && a.uaid !== payload })
    }
}
const actions = {
    start({ state, dispatch }) {

        dispatch('getOfferings')
            .then(() => {
            })
            .catch(() => { })
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    cycle({ }) { },
    createOfferings({ commit }, payload) { },
    deleteOfferings({ commit }, payload) {
        return api.get('/offering', {})
            .then(res => {
                // merge returns with our data
                commit('merge', res.data.encrypt.data)
                return Promise.resolve(res.data.encrypt.data)
            })
            .catch(err => {
                console.error(`Error during fetch: ${err}`)
                return Promise.reject(err)
            })
    },
    apiDeletePortfolioOfferingsByWorkspace({ commit }, payload) {
        let url = `${router.currentRoute.params.account_id}/${payload.workspace_id}/company/portfolio_offering/${payload.ucid}`;
        return api.delete(url)
            .then(res => {
                return Promise.resolve()
            })
            .catch(err => {
                return Promise.reject(err)
            })

    },
    apiDeletePortfolioOfferings({ commit }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/company/portfolio_offering/${payload.ucid}`;
        return api.delete(url)
            .then(res => {
                return Promise.resolve()
            })
            .catch(err => {
                return Promise.reject(err)
            })

    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}